import makeStyles from '@mui/styles/makeStyles';
import colors from '../colors';
import fontStyles from '../fontStyles';

const styles = makeStyles(() => ({
  calorieDisclaimer: {
    ...fontStyles.bodySmall,
    margin: '18px 0 64px',
    color: colors.gray600
  },
  calorieDisclaimerWithLessMargin: {
    ...fontStyles.bodySmall,
    margin: '18px 0 16px',
    color: colors.gray600
  }
}));

export default styles;
